import { jsx as e } from "react/jsx-runtime";
const a = () => /* @__PURE__ */ e("div", { className: "flex h-full w-full items-center justify-center", children: /* @__PURE__ */ e("div", { className: "border-background-secondary border-t-accent border-l-accent h-10 w-10 animate-spin rounded-full border-4" }) }), d = () => /* @__PURE__ */ e("div", { className: "border-t-accent border-l-accent mx-auto h-7 w-7 animate-spin rounded-full border-2 border-white" });
export {
  d as Loader,
  a as PageLoader
};
//# sourceMappingURL=index.js.map
